"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DueInfo;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _classnames = _interopRequireDefault(require("classnames"));

var _distance_in_words_to_now = _interopRequireDefault(require("date-fns/distance_in_words_to_now"));

var _is_past = _interopRequireDefault(require("date-fns/is_past"));

var s = {
  dueText: function dueText(theme, isMobile) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("font-size:", isMobile ? '12px' : '14px', ";color:", theme.color.dark.ruby, ";display:flex;align-items:flex-end;line-height:1;")
    );
  }
};

function DueInfo(props, key) {
  var theme = props.theme,
      dueInfo = props.dueInfo,
      isMobile = props.isMobile,
      customClassName = props.customClassName;

  if (!dueInfo || !dueInfo.dueDate) {
    return null;
  }

  var dueDate = dueInfo.dueDate;
  var distance = (0, _distance_in_words_to_now.default)(dueDate);
  var isOverdue = (0, _is_past.default)(dueDate);
  var dueText = isOverdue ? "".concat(distance, " overdue") : "Due in ".concat(distance);
  return _react.default.createElement("div", {
    key: key,
    className: (0, _classnames.default)(s.dueText(theme, isMobile), customClassName)
  }, dueText);
}